import { axios } from '../../services/axios';

export default function getGCCHServiceProfileRegions({ scope }) {
    return axios.get(
        `/ServiceProfiles/DirectRoutingGCCH/${scope}/Regions/Available`,
    );
}
